export const customButtonStyles = {
  backgroundColor: "#4747A1",
  borderColor: "#4747A1",
  color: "white",
  textTransform: "unset",
  marginTop: "20px",
  fontFamily: "Nunito, sans-serif",
};

export const registerPatientButtonStyles = {
  backgroundColor: "#4747A1",
  borderColor: "#4747A1",
  color: "white",
  "&:hover": {
    backgroundColor: "#5b5bc9ff",
  },
  textTransform: "unset",
  fontFamily: "Nunito, sans-serif",
  boxShadow: "rgba(75, 59, 159, 0.73)",
};
export const cancelButtonStyles = {
  backgroundColor: "rgba(163, 164, 165, 0.2)",
  borderColor: "#282f3a",
  "&:hover": {
    backgroundColor: "#FEFEFE",
  },
  color: "black",
  textTransform: "unset",
  fontFamily: "Nunito, sans-serif",
};
export const addButtonPadding = {
  padding: "6px 12px",
};
export const footerButtonWidth = {
  width: "80px",
  maxWidth: "80px",
  padding: "8px 20px",
};
export const BrowseFileButton = {
  backgroundColor: "#53D8F3",
  borderColor: "#53D8F3",
  color: "white",
  "&:hover": {
    backgroundColor: "#53D8F3",
  },
  textTransform: "unset",
  fontFamily: "Nunito, sans-serif",
};

export const SignOutButton = {
  backgroundColor: "#FEFEFE",
  borderColor: "#E5E5E5",
  color: "#FD5162",
  "&:hover": {
    backgroundColor: "#FEFEFE",
  },
  textTransform: "unset",
  fontFamily: "Nunito, sans-serif",
};

export const assignslotButton = {
  backgroundColor: "#FFFFFF",
  borderColor: "#0025DC",
  color: "#0025DC",
  "&:hover": {
    backgroundColor: "#FEFEFE",
  },
  textTransform: "unset",
  fontFamily: "Nunito, sans-serif",
};
export const printInvoiceButton = {
  backgroundColor: "rgba(75, 73, 172, 0.2)",
  borderColor: "#D72554",
  "&:hover": {
    backgroundColor: "#FEFEFE",
  },
  textTransform: "unset",
  fontSize: "15px",
  marginRight: "10px",
  border: "1px solid",
  padding: "5px",
  cursor: "pointer",
  color: "#4B49AC",
  borderRadius: "50%",
  fontFamily: "Nunito, sans-serif",
};
export const editPatientButton = {
  backgroundColor: "rgba(163, 164, 165, 0.2)",
  borderColor: "#282f3a",
  "&:hover": {
    backgroundColor: "#FEFEFE",
  },
  textTransform: "unset",
  fontSize: "15px",
  marginRight: "10px",
  border: "1px solid",
  padding: "5px",
  cursor: "pointer",
  color: "#282f3a",
  borderRadius: "50%",
  fontFamily: "Nunito, sans-serif",
};
export const DeletePatientButton = {
  backgroundColor: "rgba(255, 71, 71, 0.2)",
  borderColor: "#FF4747",
  "&:hover": {
    backgroundColor: "#FEFEFE",
  },
  textTransform: "unset",
  fontSize: "15px",
  marginRight: "10px",
  border: "1px solid",
  padding: "5px",
  cursor: "pointer",
  color: "#FF4747",
  borderRadius: "50%",
  fontFamily: "Nunito, sans-serif",
};
export const invoiceApprovalButton = {
  backgroundColor: "rgba(75, 73, 172, 0.2)",
  borderColor: "#D72554",
  "&:hover": {
    backgroundColor: "#FEFEFE",
  },
  textTransform: "unset",
  fontSize: "15px",
  marginRight: "10px",
  border: "1px solid",
  padding: "5px",
  cursor: "pointer",
  color: "#4B49AC",
  borderRadius: "50%",
  fontFamily: "Nunito, sans-serif",
};
